import { Component, Input, OnInit, Output, EventEmitter, OnChanges, ViewChild } from '@angular/core';
import { BlogService } from '../../services/blog/blog.service';
import { Subscription, combineLatest, of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';
import { UsersService } from 'src/app/services/users/users.service';
import { faAngleDoubleRight, faAngleDoubleLeft } from '@fortawesome/free-solid-svg-icons';
import { IonSlides, IonicModule } from '@ionic/angular';
import { NucampanalyticsService } from 'src/app/services/nucampanalytics/nucampanalytics.service';
import { NucampdatePipe } from '../../pipes/nucampdate/nucampdate.pipe';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { RouterLink } from '@angular/router';
import { NgIf, NgFor } from '@angular/common';

/**
 * Generated class for the RelatedblogsComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    styleUrls: ['./relatedblogs.scss'],
    selector: 'relatedblogs',
    templateUrl: 'relatedblogs.html',
    standalone: true,
    imports: [NgIf, IonicModule, NgFor, RouterLink, FontAwesomeModule, NucampdatePipe]
})
export class RelatedblogsComponent implements OnChanges {
  @Input() blog: any;
  @Input() relatedBy: string;
  @Input() relatedByField: string;
  @Input() display: string;
  @Input() maxBlogs: number;
  @Output() openblog: EventEmitter<any> = new EventEmitter();
  @ViewChild('relatedblogsSlider') relatedblogsSlider: IonSlides

  blogs;
  sub: Subscription;
  isBlogEditor;
  faAngleDoubleRight = faAngleDoubleRight;
  faAngleDoubleLeft = faAngleDoubleLeft;
  relatedblogsSliderOptions = {
    pagination: {el: '.swiper-pagination',type: 'bullets',clickable: true},
    navigation: {nextEl: '.nucamp-swiper-button-next', prevEl: '.nucamp-swiper-button-prev'},
    loop: true,
    pager: true,
    slidesPerView: 3,
    slidesPerGroup: 3,
    breakpoints: {
      200: {slidesPerView: 1.1},
      720: {slidesPerView: 2.2},
      1100: {slidesPerView: 3.2},
    },
  };

  constructor(
    private blogp: BlogService,
    private userProvider: UsersService,
    private nucampAnalytics: NucampanalyticsService
  ) {
  }

  ngOnChanges() {
    // console.log("relatedBy", this.relatedBy);
    // console.log("relatedByField", this.relatedByField);
    if (!this.maxBlogs) this.maxBlogs = 8;
    this.sub = this.loadRelatedBlogs(this.relatedBy, this.maxBlogs)
      .subscribe(blogs => {
        if (blogs && blogs.length > 0) {
          this.blogs = blogs.filter(blog => this.blog ? blog.shortid !== this.blog.shortid : true);
        }
      });
  }

  async swipePrevBlog() {
    await Promise.all([
      this.relatedblogsSlider.slidePrev(),
      this.nucampAnalytics.event("Page", "Slider", `Community Blogs  | ${location}`),
      this.nucampAnalytics.browseWebsite(this.userProvider.loggedUser)
    ]);
  }

  async swipeNextBlog() {
    await Promise.all([
      this.relatedblogsSlider.slideNext(),
      this.nucampAnalytics.event("Page", "Slider", `Community Blogs  | ${location}`),
      this.nucampAnalytics.browseWebsite(this.userProvider.loggedUser)
    ]);
  }

  loadRelatedBlogs(relatedBy, nBlogs) {
    if (relatedBy && relatedBy !== "") {
      // console.log("here1");
      return this.blogp.getRelatedBlogs(relatedBy, this.relatedByField, nBlogs)
    } else if (this.blog && this.blog.communityid && this.blog.communityid !== "No Specific Community") {
      // console.log("here2");
      return this.blogp.getRelatedBlogs("community", this.relatedByField, nBlogs)
    } else if (this.blog && this.blog.tags) {
      // console.log("here3");
      return this.blogp.getRelatedBlogs("tags", this.blog.tags, nBlogs)
    } else {
      // console.log("here4");
      return this.blogp.getRelatedBlogs("date", null, nBlogs)
    }
  }

  ionViewWillLeave() {
    if (this.sub) this.sub.unsubscribe();
  }

  openBlog(shortid) {
    this.openblog.emit(shortid)
  }
}
